__turbopack_context__.v({
  "advancedSearchLink": "styles-module-scss-module__i0IVKG__advancedSearchLink",
  "backButton": "styles-module-scss-module__i0IVKG__backButton",
  "brandCategoryPage": "styles-module-scss-module__i0IVKG__brandCategoryPage",
  "brandIdentity": "styles-module-scss-module__i0IVKG__brandIdentity",
  "brandInitial": "styles-module-scss-module__i0IVKG__brandInitial",
  "brandLogo": "styles-module-scss-module__i0IVKG__brandLogo",
  "brandName": "styles-module-scss-module__i0IVKG__brandName",
  "brandTitle": "styles-module-scss-module__i0IVKG__brandTitle",
  "buttonContainer": "styles-module-scss-module__i0IVKG__buttonContainer",
  "closeContainer": "styles-module-scss-module__i0IVKG__closeContainer",
  "description": "styles-module-scss-module__i0IVKG__description",
  "descriptionSection": "styles-module-scss-module__i0IVKG__descriptionSection",
  "filterToggleButton": "styles-module-scss-module__i0IVKG__filterToggleButton",
  "mainContent": "styles-module-scss-module__i0IVKG__mainContent",
  "mobileBrandHeader": "styles-module-scss-module__i0IVKG__mobileBrandHeader",
  "mobileBrandIdentity": "styles-module-scss-module__i0IVKG__mobileBrandIdentity",
  "mobileBrandInfo": "styles-module-scss-module__i0IVKG__mobileBrandInfo",
  "mobilePopularModels": "styles-module-scss-module__i0IVKG__mobilePopularModels",
  "modelLink": "styles-module-scss-module__i0IVKG__modelLink",
  "modelsContainer": "styles-module-scss-module__i0IVKG__modelsContainer",
  "onlyLarge": "styles-module-scss-module__i0IVKG__onlyLarge",
  "popularModels": "styles-module-scss-module__i0IVKG__popularModels",
  "popularModelsSection": "styles-module-scss-module__i0IVKG__popularModelsSection",
  "readMoreButton": "styles-module-scss-module__i0IVKG__readMoreButton",
  "sidebar": "styles-module-scss-module__i0IVKG__sidebar",
  "sidebarContent": "styles-module-scss-module__i0IVKG__sidebarContent",
  "websiteLink": "styles-module-scss-module__i0IVKG__websiteLink",
});
